"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.start.failed': 'Failed to start recording',
};
